import React from 'react';

import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import EditableNumericInputField from 'ui-library/inputs/EditableNumericInputField';

export interface EditableLocationCapacityFieldProps {
  disabled?: boolean;
  capacity: number | null;
  onChange: (value: number | null) => void;
  onChangeHasCapacityError?: (hasError?: boolean) => void;
  isForCreate?: boolean;
  isFullWidth?: boolean;
  dataTestAttrs?: DataTestAttrs;
  shouldUseCompactDisplay?: boolean;
}

// Keep in sync with benchling/inventory/validate:LOCATION_CAPACITY_PRODUCT_LIMIT
// Constrained by need to bound the queries for calculating occupied/available capacity used in domain graph
// and warehouse. Low-mid 1000s is acceptable, but higher would need special handling.
export const LOCATION_CAPACITY_PRODUCT_LIMIT = 1000;

export function EditableLocationCapacityField(props: EditableLocationCapacityFieldProps): JSX.Element {
  return (
    <EditableNumericInputField
      value={props.capacity}
      onChange={props.onChange}
      invalidValueErrorText={`Capacity must be an integer between 1 and ${LOCATION_CAPACITY_PRODUCT_LIMIT}`}
      shouldValidateInteger={true}
      min={1}
      max={LOCATION_CAPACITY_PRODUCT_LIMIT}
      onChangeHasError={props.onChangeHasCapacityError}
      isDisabled={props.disabled}
      isForCreate={props.isForCreate}
      isFullWidth={props.isFullWidth}
      dataTestAttrs={props.dataTestAttrs}
      shouldUseCompactDisplay={props.shouldUseCompactDisplay}
      placeholder="Unlimited"
    />
  );
}
